import { CardElement } from "@/types/battle"
import { assetUrl } from "@/constants/assetUrl"
import { PLAYER_AVATARS_BY_ELEMENT } from "@/constants/playerAvatars"

export const MAP_PLAYER_MARKERS_BY_ELEMENT: Record<CardElement, string> = {
  FIRE: PLAYER_AVATARS_BY_ELEMENT.FIRE[0],
  WATER: PLAYER_AVATARS_BY_ELEMENT.WATER[0],
  EARTH: PLAYER_AVATARS_BY_ELEMENT.EARTH[0],
  WIND: PLAYER_AVATARS_BY_ELEMENT.WIND[0],
  ICE: PLAYER_AVATARS_BY_ELEMENT.ICE[0],
  LIGHTNING: PLAYER_AVATARS_BY_ELEMENT.LIGHTNING[0],
}

export const MAP_PLAYER_RANK_FRAMES_BY_ELEMENT: Record<CardElement, string> = {
  FIRE: assetUrl("maps/fireRound.png"),
  WATER: assetUrl("maps/waterRound.png"),
  EARTH: assetUrl("maps/earthRound.png"),
  WIND: assetUrl("maps/windRound.png"),
  ICE: assetUrl("maps/iceRound.png"),
  LIGHTNING: assetUrl("maps/lightRound.png"),
}

export const MAP_SHOP_MARKER = assetUrl("maps/shop.png")
export const MAP_MAIL_MARKER = assetUrl("maps/mail.png")
export const MAP_TREASURE_MARKER = assetUrl("lor/klad.png")
export const MAP_STARFALL_MARKER = assetUrl("maps/starsfall.png")
export const MAP_BANK_MARKER = assetUrl("lor/monet.png")
export const MAP_CITY_HALL_MARKER = assetUrl("maps/ratusha.png")
export const MAP_HOTEL_MARKER = assetUrl("lor/hotel.png")
export const MAP_WISE_TREE_MARKER = assetUrl("maps/trent.png")
export const MAP_HANGAR_MARKER = assetUrl("maps/hangar.png")
export const MAP_AIRSHIP_MARKER = assetUrl("lor/profile/dirizhabl.png")
export const MAP_BASE_TITAN_MARKER = assetUrl("maps/base_titan.png")
export const MAP_BASE_ATLANT_MARKER = assetUrl("maps/base_atlant.png")

export const MAP_SCAN_LOCATION_BY_LEAGUE = {
  NEUTRAL: assetUrl("maps/location.png"),
  TITAN: assetUrl("maps/titanLocation.png"),
  ATLANT: assetUrl("maps/atlantLocation.png"),
} as const

export const MAP_BOSS_MARKERS = [
  assetUrl("maps/boss.png"),
  assetUrl("maps/boss-1.png"),
  assetUrl("maps/boss-2.png"),
  assetUrl("maps/boss-3.png"),
  assetUrl("maps/boss-4.png"),
  assetUrl("maps/boss-5.png"),
] as const

export const MAP_WORLD_BOSS_MARKER = assetUrl("maps/megaBoss.png")
